import { useEffect, useId, useState } from 'react';
import type { ReactNode } from 'react';
import { lessonStore } from '../lib/lesson';
import { useStore } from '../lib/store';

/** N harfi kalem izi gibi çizilir, üstünde "nova" yıldızı durur. Sekme simgesi public/favicon.svg ile aynıdır. */
export function NovaMark({ size = 28 }: { size?: number }) {
  const gradient = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className="nova-mark">
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2A2FA8" />
          <stop offset="1" stopColor="#6348CB" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${gradient})`} />
      <path d="M8.5 24V9.5L20 22.5V13" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.5 4.5c.4 2.7 2.1 4.4 4.8 4.8-2.7.4-4.4 2.1-4.8 4.8-.4-2.7-2.1-4.4-4.8-4.8 2.7-.4 4.4-2.1 4.8-4.8z" fill="#D9D1FF" />
    </svg>
  );
}

export function IconButton(props: {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  active?: boolean;
  danger?: boolean;
  children: ReactNode;
  className?: string;
}) {
  const cls = ['icon-btn', props.active ? 'is-active' : '', props.danger ? 'is-danger' : '', props.className ?? ''].join(' ').trim();
  return (
    <button type="button" className={cls} title={props.label} aria-label={props.label} aria-pressed={props.active} disabled={props.disabled} onClick={props.onClick}>
      {props.children}
    </button>
  );
}

export function Toggle(props: { checked: boolean; onChange: (v: boolean) => void; label: string; hint?: string; disabled?: boolean }) {
  return (
    <label className={`toggle ${props.disabled ? 'is-disabled' : ''}`}>
      <span className="toggle-text">
        <span>{props.label}</span>
        {props.hint && <small>{props.hint}</small>}
      </span>
      <input type="checkbox" checked={props.checked} disabled={props.disabled} onChange={(e) => props.onChange(e.target.checked)} />
      <span className="toggle-track" aria-hidden="true">
        <span className="toggle-thumb" />
      </span>
    </label>
  );
}

export function CenterCard(props: { title: string; text?: string; children?: ReactNode }) {
  return (
    <div className="center-screen">
      <div className="card center-card">
        <NovaMark size={40} />
        <h1>{props.title}</h1>
        {props.text && <p className="muted">{props.text}</p>}
        {props.children}
      </div>
    </div>
  );
}

export function Toast() {
  const toast = useStore(lessonStore, (s) => s.toast);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!toast) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2800);
    return () => clearTimeout(t);
  }, [toast?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!toast || !visible) return null;
  return (
    <div className="toast" role="status" aria-live="polite">
      {toast.text}
    </div>
  );
}
